import type { ValueEvent } from '@adornis/base/utilTypes.js';
import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import '@chancenwerk/client/components/chancen-component-card-title.js';
import { ChancenPermission } from '@chancenwerk/shared/permissions.js';
import '@chancenwerk/client/design/components/cr-dropdown-selection.js';
import { CrPage } from '@chancenwerk/client/design/components/cr-page.js';
import { MarktAPI } from '@chancenwerk/markt/api/MarktAPI.js';
import { MarktAkquise } from '@chancenwerk/markt/entities/MarktAkquise.js';
import { MarktAkquiseContactRecord } from '@chancenwerk/markt/entities/MarktAkquiseContactRecord.js';
import { html, nothing } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { of, switchMap, tap } from 'rxjs';
import '../components/markt-component-contact-manager.js';

/**
 * @customElement markt-page-akquise
 */
@customElement('markt-page-akquise')
export class MarktPageAkquise extends CrPage {
  @property() marktAkquiseID = new RXController(this, '');

  @state() _data = new RXController(
    this,
    this.marktAkquiseID.observable.pipe(
      switchMap(async id => {
        if (!id || id === '') return of(null);

        await MarktAPI.ensureMarktAkquise(id)();
        return MarktAPI.subscribeMarktAkquise(id)({
          ...MarktAkquise.allFields,
          contacts: {
            ...MarktAkquiseContactRecord.allFields,
            from: {
              _id: 1,
              vorname: 1,
              nachname: 1,
              email: 1,
            },
            to: {
              _id: 1,
              vorname: 1,
              nachname: 1,
              email: 1,
            },
          },
          partner: {
            name: 1,
            kuerzel: 1,
          },
        });
      }),
      switchMap(obs => obs),
      tap(val => {
        if (!val) {
          return;
        }

        this.label = `${val.partner?.kuerzel ?? ''}: ${val.partner?.name ?? ''}`;
        this.description = `Fachbereichs-Akquise`;
      }),
    ),
  );

  constructor() {
    super();

    this.label = 'Fachbereichs-Akquise';
    this.description = '';
    this.permission = ChancenPermission.markt.LOGIN_MARKT;
    this.backRoute = '/';
  }

  override header() {
    return html`todo`;
  }

  private _dataView() {
    if (!this._data.value) {
      return nothing;
    }

    this._data.value.contacts ??= [];
    return html`<markt-component-contact-manager
      .contacts=${this._data.value?.contacts ?? []}
      @record-edited=${async () => this._data.value?.save()}
      @record-added=${async (e: ValueEvent<MarktAkquiseContactRecord>) => {
        this._data.value?.contacts?.push(e.detail.value);
        await this._data.value?.save();
      }}
      @record-deleted=${async (e: ValueEvent<MarktAkquiseContactRecord>) => {
        this._data.value?.contacts?.splice(this._data.value.contacts.indexOf(e.detail.value), 1);
        await this._data.value?.save();
      }}
    ></markt-component-contact-manager>`;
  }

  override content() {
    return html`
      <cr-flex padding="sm" space="md">
        <cr-card space="md" padding="md">
          <chancen-component-card-title>Kontakte</chancen-component-card-title>
          ${this._dataView()}
      </cr-flex>
    `;
  }
}
